export const categories = [
  {
    id: "shoes",
    name: "Shoes",
    namePt: "Sapatos",
    description: "Tênis, sapatos casuais e esportivos dos melhores vendedores",
    icon: "ri-footprint-line",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Single%20premium%20white%20leather%20sneaker%20photographed%20in%20clean%20editorial%20style%20on%20warm%20beige%20textured%20surface%20soft%20studio%20lighting%20with%20subtle%20shadow%20minimalist%20product%20photography%20elegant%20aesthetic%20no%20text%20no%20logos%20neutral%20tones&width=600&height=400&seq=cat-shoes-v2&orientation=landscape",
  },
  {
    id: "hoodies-sweaters",
    name: "Hoodies/Sweaters",
    namePt: "Moletons/Suéteres",
    description: "Moletons, suéteres e agasalhos de alta qualidade",
    icon: "ri-t-shirt-line",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20cream%20colored%20cotton%20hoodie%20draped%20elegantly%20on%20wooden%20hanger%20against%20warm%20oatmeal%20toned%20background%20soft%20natural%20light%20editorial%20fashion%20photography%20minimal%20style%20no%20text%20no%20logos&width=600&height=400&seq=cat-hoodies-v2&orientation=landscape",
  },
  {
    id: "t-shirts",
    name: "T-Shirts",
    namePt: "Camisetas",
    description: "Camisetas casuais, estampadas e básicas verificadas",
    icon: "ri-t-shirt-air-line",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20white%20cotton%20t-shirt%20folded%20neatly%20on%20light%20sand%20colored%20linen%20surface%20soft%20diffused%20daylight%20from%20above%20editorial%20product%20photography%20minimalist%20aesthetic%20no%20text%20no%20logos&width=600&height=400&seq=cat-tshirts-v2&orientation=landscape",
  },
  {
    id: "jackets",
    name: "Jackets",
    namePt: "Jaquetas",
    description: "Jaquetas, casacos e corta-ventos dos melhores fornecedores",
    icon: "ri-shirt-line",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20olive%20green%20bomber%20jacket%20laid%20flat%20on%20warm%20stone%20colored%20surface%20natural%20window%20light%20creating%20gentle%20shadows%20editorial%20fashion%20flat%20lay%20minimal%20composition%20no%20text%20no%20logos&width=600&height=400&seq=cat-jackets-v2&orientation=landscape",
  },
  {
    id: "pants-shorts",
    name: "Pants/Shorts",
    namePt: "Calças/Shorts",
    description: "Calças jeans, shorts e bermudas com melhor custo-benefício",
    icon: "ri-pantone-line",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20beige%20chino%20pants%20folded%20elegantly%20on%20light%20cream%20colored%20textured%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20clean%20composition%20no%20text%20no%20logos&width=600&height=400&seq=cat-pants-v2&orientation=landscape",
  },
  {
    id: "headwear",
    name: "Headwear",
    namePt: "Chapéus/Bonés",
    description: "Bonés, gorros e acessórios de cabeça estilosos",
    icon: "ri-base-station-line",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20cream%20colored%20baseball%20cap%20placed%20on%20warm%20sandstone%20surface%20with%20soft%20natural%20side%20lighting%20creating%20subtle%20shadows%20clean%20product%20photography%20elegant%20neutral%20aesthetic%20no%20text&width=600&height=400&seq=cat-headwear-v2&orientation=landscape",
  },
  {
    id: "sets",
    name: "Sets",
    namePt: "Conjuntos",
    description: "Conjuntos completos de roupas coordenadas",
    icon: "ri-group-line",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20cream%20and%20beige%20loungewear%20set%20folded%20artfully%20on%20light%20warm%20toned%20surface%20with%20gentle%20natural%20lighting%20editorial%20fashion%20flat%20lay%20minimal%20style%20no%20text%20no%20logos&width=600&height=400&seq=cat-sets-v2&orientation=landscape",
  },
  {
    id: "underwear",
    name: "Underwear/Underpants",
    namePt: "Roupa Íntima",
    description: "Roupas íntimas e cuecas de qualidade verificada",
    icon: "ri-user-line",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20set%20arranged%20neatly%20on%20soft%20warm%20beige%20linen%20surface%20diffused%20natural%20light%20minimalist%20product%20photography%20clean%20aesthetic%20no%20text%20no%20logos&width=600&height=400&seq=cat-underwear-v2&orientation=landscape",
  },
  {
    id: "jersey",
    name: "Jersey",
    namePt: "Camisas de Time",
    description: "Camisas de futebol e jerseys esportivas autênticas",
    icon: "ri-football-line",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Vintage%20style%20cream%20colored%20sports%20jersey%20laid%20flat%20on%20warm%20sandstone%20surface%20with%20soft%20studio%20lighting%20editorial%20product%20photography%20minimal%20composition%20no%20text%20no%20logos&width=600&height=400&seq=cat-jersey-v2&orientation=landscape",
  },
  {
    id: "accessories",
    name: "Accessories",
    namePt: "Acessórios",
    description: "Óculos, relógios, carteiras e acessórios diversos",
    icon: "ri-glasses-line",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20sunglasses%20and%20leather%20bracelet%20arranged%20artfully%20on%20warm%20beige%20textured%20surface%20soft%20natural%20window%20light%20elegant%20product%20flat%20lay%20no%20text%20no%20logos&width=600&height=400&seq=cat-accessories-v2&orientation=landscape",
  },
  {
    id: "bags",
    name: "Bags",
    namePt: "Bolsas/Mochilas",
    description: "Mochilas, bolsas e malas dos vendedores mais confiáveis",
    icon: "ri-briefcase-line",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20canvas%20backpack%20photographed%20on%20light%20stone%20colored%20surface%20with%20soft%20directional%20lighting%20editorial%20product%20photography%20clean%20minimalist%20aesthetic%20no%20text%20no%20logos&width=600&height=400&seq=cat-bags-v2&orientation=landscape",
  },
  {
    id: "belts",
    name: "Belts",
    namePt: "Cintos",
    description: "Cintos de couro e tecido com excelente acabamento",
    icon: "ri-link",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20braided%20leather%20belt%20coiled%20gracefully%20on%20warm%20cream%20colored%20surface%20soft%20natural%20lighting%20creating%20gentle%20shadows%20product%20photography%20no%20text%20no%20logos&width=600&height=400&seq=cat-belts-v2&orientation=landscape",
  },
  {
    id: "perfumes",
    name: "Perfumes",
    namePt: "Perfumes",
    description: "Perfumes e fragrâncias importadas com preços imbatíveis",
    icon: "ri-drop-line",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20glass%20perfume%20bottle%20on%20warm%20sandstone%20surface%20with%20soft%20diffused%20lighting%20and%20subtle%20reflections%20editorial%20product%20photography%20clean%20aesthetic%20no%20text%20no%20logos&width=600&height=400&seq=cat-perfumes-v2&orientation=landscape",
  },
  {
    id: "other-stuff",
    name: "Other Stuff",
    namePt: "Outros Itens",
    description: "Itens diversos, eletrônicos e achados especiais",
    icon: "ri-more-line",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20products%20including%20small%20gadgets%20and%20accessories%20arranged%20organically%20on%20warm%20beige%20surface%20soft%20natural%20lighting%20editorial%20flat%20lay%20photography%20harmonious%20composition%20no%20text&width=600&height=400&seq=cat-other-v2&orientation=landscape",
  },
];